import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_CONTENTS_ATTEMPT_STATE } from '../../../constants/createSendContentsAttempt';
import { ICreateSendContentsAttemptState } from '../../../types/createSendContentsAttempt';
import * as AuthActions from '../../actions/auth';
import * as ContentsAttemptActions from '../actions/contentsAttempt';

export const initialState: ICreateSendContentsAttemptState = DEFAULT_CREATE_SEND_CONTENTS_ATTEMPT_STATE;

const reducer = (
  state: ICreateSendContentsAttemptState = initialState,
  action: any,
): ICreateSendContentsAttemptState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case ContentsAttemptActions.CS_CONTENTS_CONTINUE_ATTEMPTED: {
      return {
        attemptedUnsetKey: action.payload.unsetKey,
        highlightGeneration: state.highlightGeneration + 1,
      };
    }
    default:
      return state;
  }
};

export default reducer;
